module.exports = __webpack_public_path__ + "img/75688.6af3bb60.svg";